'use client';
import React, { useState, useEffect } from 'react';
import { styled, keyframes } from 'styled-components';
import { MdOutlineKeyboardArrowUp } from 'react-icons/md';

type Props = {
  onClick?: () => void;
};

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const BackToTopButton: React.FC<Props> = (props: Props) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        // 300px以上スクロールしたら表示
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {isVisible && (
        <ButtonWrapper onClick={props.onClick || scrollToTop}>
          <MdOutlineKeyboardArrowUp
            color="var(--background-image)"
            size="48px"
          />
        </ButtonWrapper>
      )}
    </>
  );
};

const ButtonWrapper = styled.button`
  padding: 0px 24px 0px 0px;
  position: fixed;
  right: 14px;
  bottom: 80px;
  background-color: var(--button-gold);
  width: 48px;
  height: 48px;
  border-radius: 99px;
  border: none;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.3),
    0px 2px 8px 1px rgba(0, 0, 0, 0.1);
  animation: ${fadeIn} 0.3s forwards;
  &:focus {
    outline: none;
  }
`;
export default BackToTopButton;
